<template>
  <a-flex class="root">
    <a-col :span="24">
      <div class="instructions">
        На этой странице Вы можете отслеживать, какие компетенции сформировались
        у участников проектов этого портфеля, а также проводить анализ
        соотношения ожидаемых и фактических результатов.
      </div>
    </a-col>

    <a-col :span="24">
      <a-flex class="cards">
        <competencies-card
          v-for="item in competencies"
          :key="item.title"
          :title="item.title"
          :items="item.items"
        />
      </a-flex>
    </a-col>
  </a-flex>
</template>

<script setup>
  import CompetenciesCard from '@/views/administrator/projects/competencies/CompetenciesCard.vue';
  import { onMounted, ref } from 'vue';
  import { CHECKPOINT_COMPETENCE_SET_STATUS_CONFIRMED } from '@/constants/checkpoint-competence-set';
  import { useApi } from '@/api/use-api';
  import { useRoute } from 'vue-router';
  import {
    COMPETENCE_TYPE_SKILL,
    COMPETENCE_TYPE_SUBJECT,
    COMPETENCE_TYPE_TECHNOLOGY,
  } from '@/api/models/CompetenceType';

  const api = useApi();
  const route = useRoute();
  const competencies = ref([]);
  const isLoading = ref(true);

  onMounted(async () => {
    await getStats();
    isLoading.value = false;
  });

  const getStats = async () => {
    try {
      const response = await api.competence.briefcaseStats(
        new URLSearchParams({
          briefcaseId: route.params.id,
          status: CHECKPOINT_COMPETENCE_SET_STATUS_CONFIRMED,
          'per-page': 100,
        })
      );

      competencies.value = [
        {
          title: 'Предметная область',
          items: response.competencies.items.filter(
            (el) => el.type === COMPETENCE_TYPE_SUBJECT
          ),
        },
        {
          title: 'Технологии',
          items: response.competencies.items.filter(
            (el) => el.type === COMPETENCE_TYPE_TECHNOLOGY
          ),
        },
        {
          title: 'Навыки',
          items: response.competencies.items.filter(
            (el) => el.type === COMPETENCE_TYPE_SKILL
          ),
        },
      ];
    } catch (error) {
      console.error('error', error);
    }
  };
</script>

<style scoped lang="scss">
  .root {
    flex-direction: column;

    .instructions {
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
      margin-top: 40px;
      max-width: 555px;
    }

    .cards {
      flex-direction: column;
      row-gap: 10px;
      margin-top: 30px;
    }
  }
</style>
